import React, { useState } from "react";

import DeleteIcon from "../../icons/deleteIconCustom"
import { ButtonDelete } from "./styles"

export default props => {
    const [styleIcon, setStyleIcon] = useState("account-button-delete-icon");

    return (
        <ButtonDelete className={props.className} style={props.style} title={props.title}>
            <div className={"account-button-delete"}
                onMouseOver={() => setStyleIcon("account-button-delete-icon account-button-delete-icon-hover ")}
                onMouseOut={() => setStyleIcon("account-button-delete-icon")}
                onClick={props.onClick}>
                <span className={styleIcon} style={props.text ? "": {borderRadius: 50}}>
                    <DeleteIcon />
                </span>
                <span className="account-button-delete-text">{props.text}</span>
            </div>
        </ButtonDelete>
    )
}
